// import utils
// import { forwardRef } from "react";
// import components
import Box from "@mui/material/Box";
// import types
// import type { ElementType, ForwardedRef } from "react";
// import type { BoxAtomPropTypes, MuiBoxTypeMap } from "@sdb/types/components/atoms/Box.types";
export const BoxAtomComponent = Box;
export default BoxAtomComponent;
